import React, { memo } from 'react'
import AddIcon from 'assets/svgr-icons/Add.svg'
import * as Styled from './styled'
import { SpinningLoader } from 'common-components'
import { COLORS } from 'consts/colors'
import { IProps } from './types'

const AddReferenceImageButton: React.FC<IProps> = ({
  toggleDropdown,
  isOpen,
  setAddImageWrapperElement,
  isUploading
}) => {
  return (
    <Styled.ReferenceImagesOuterContainer
      onClick={toggleDropdown}
      ref={setAddImageWrapperElement}
    >
      {isUploading ? (
        <Styled.LoadingSpinnerWrapper>
          <SpinningLoader
            className="loading-spinner"
            size={32}
            loaderColor={COLORS.primaryDark}
          />
        </Styled.LoadingSpinnerWrapper>
      ) : (
        <Styled.AddImageIconWrapper $isToggled={isOpen}>
          <AddIcon />
        </Styled.AddImageIconWrapper>
      )}
    </Styled.ReferenceImagesOuterContainer>
  )
}

export default memo(AddReferenceImageButton)
